<template>
    <div class="group">
        <div class="group-title">
            <div class="group-title-name">
                {{group.name}}
              <span class="operate" @click="handleEditOrgName(group)"> <i class="iconfont icon-zidingyi"></i> {{$t('bian_ji')}}</span>
            </div>
            <p class="group-title-operate">
              <span class="operate delete" @click="handleDeleteGroup">{{$t('shan_chu_fen_zu')}}</span>
              <span class="split">//</span>
                <span class="operate" @click="handleAddGroup">{{$t('xin_zeng_fen_zu')}}</span>
                <span class="split">//</span>
                <span class="operate" @click="handleAddUser()">{{$t('xin_zeng_cheng_yuan')}}</span>
                <span class="split">//</span>
                <span class="operate" @click="handleAllocateDevice">{{$t('fen_pei_she_bei')}}</span>
            </p>
        </div>

        <el-row class="group-filter" :gutter="4">
            <el-col class="group-list-filter" :span="14">
                <span :class="{'active': table=='users'}" @click="showUsers">{{$t('ben_ji_cheng_yuan')}}</span>
                <span :class="{'active': table=='devices'}" @click="showDevices">{{$t('xiang_guan_she_bei')}}</span>
            </el-col>
            <el-col :span="8">
                <el-input :placeholder="searchHolder" class="line-input-filter"
                          @change="search"
                          suffix-icon="el-icon-search" v-model="searchInfo"></el-input>
            </el-col>
        </el-row>
        <div class="group-list-item">
            <users v-show="table=='users'" ref="userList"></users>
            <devices v-show="table=='devices'" ref="deviceList"></devices>
        </div>
        <c-dialog :visible.sync="addGroupVisible" :title="$t('xin_zeng_fen_zu')" :width="'20rem'" :height="'10rem'">
            <el-input :placeholder="$t('qing_shu_ru_fen_zu_ming_cheng')" class="input" v-model="departmentName"></el-input>
            <el-row :gutter="8" class="group-btn">
                <el-col :span="12">
                    <el-button type="primary" @click="createDepartment">{{$t('que_ding')}}</el-button>
                </el-col>
                <el-col :span="12">
                    <el-button class="cancel" @click="addGroupVisible=false">{{$t('qu_xiao')}}</el-button>
                </el-col>

            </el-row>
        </c-dialog>
        <c-dialog :visible.sync="addUserVisible" :title="$t('xin_zeng_cheng_yuan')" :width="'30rem'" :height="'27rem'">
            <el-form label-width="120px" class="add-user-form">
                <el-form-item :label="$t('cheng_yuan_ming_cheng')">
                    <el-input :placeholder="$t('qing_shu_ru_cheng_yuan_ming_cheng')" v-model="user.name"/>
                </el-form-item>
                <el-form-item :label="$t('tou_xiang')">
                    <img class="department-user-img" :src="user.avatar" alt="">
                </el-form-item>
                <el-form-item :label="$t('shou_ji')">
                    <el-input :placeholder="$t('qing_shu_ru_cheng_yuan_shou_ji')" v-model="user.phone"/>
                </el-form-item>
                <el-form-item :label="$t('deng_lu_mi_ma')">
                    <el-input :placeholder="$t('qing_shu_ru_cheng_yuan_deng_lu_mi_ma')" v-model="user.password"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleDepartmentBindUser">{{$t('que_ding')}}</el-button>
                </el-form-item>
            </el-form>
        </c-dialog>

        <c-dialog class="dialog" :visible.sync="allocatedVisible" :width="'50rem'" :height="'37.5rem'"
                  :outer-close="false"
                  :title="$t('fen_pei_she_bei')">

            <el-button slot="title" size="mini" type="primary" @click="deviceAllocate">{{$t('bao_cun')}}</el-button>

            <allocation-device ref="allocDevice" slot="default"></allocation-device>
        </c-dialog>
    </div>
</template>

<script>
    import Users from '@/components/Users'
    import Devices from './device'
    import AllocationDevice from '@/components/AllocateDevice'
    import CDialog from '@/components/Dialog'
    import {groupCreate, departmentBindUser, departmentUpdateName, departmentDelete} from '@/api/delivery/organization/group'
    import {checkPhone} from '@/util/checkLogin'
    import {deviceAllocateGroup} from '@/api/delivery/device/allocate'
    import {hex_md5} from '@/util/md5'
    export default {
        name: '',
        components: {
            Users,
            CDialog,
            Devices,
            AllocationDevice
        },
        props: {
            newDepartment: {
                type: Function,
                default: null
            }
        },
        mounted: function () {
        },
        computed: {
            searchHolder(){
                if (this.table === 'users') {
                    return this.placeholder
                }
                return this.$t('qing_shu_ru_she_bei_bian_hao')
            }
        },
        data: function () {
            return {
                group: {
                    name: '',
                    uuid: ''
                },
                searchInfo: '',
                user: {
                    departmentUuid: '',
                    name: '',
                    avatar: 'https://sass-img.iyyclub.com/avatar.jpg',
                    phone: '',
                    password: ''
                },
                fileList: [],
                departmentName: '',
                addGroupVisible: false,
                addUserVisible: false,
                allocatedVisible: false,
                table: 'users',
                placeholder: this.$t('qing_shu_ru_cheng_yuan_ming_cheng'),
            }
        },
        methods: {
            setGroup(group){
                this.departmentName = ''
                this.group = group
                this.table = `users`
                this.$refs.userList.initDepartment(group.uuid)
            },
            handleAddGroup() {
                this.addGroupVisible = true
            },
          handleDeleteGroup() {
            this.$confirm(this.$t('shan_chu_fen_zu'),  this.$t('ti_shi'), {
              confirmButtonText: this.$t('que_ding'),
              cancelButtonText: this.$t('qu_xiao'),
            }).then(action => {
              departmentDelete({
                uuid: this.group.uuid,
              }).then(res => {
                this.$message.success(this.$t('shan_chu_cheng_gong'))
                if (this.newDepartment !== null) {
                  this.newDepartment()
                }
              })
            })
          },

            handleEditOrgName(dept) {
              this.$prompt(this.$t('edit_department_name'),  this.$t('ti_shi'), {
                confirmButtonText: this.$t('que_ding'),
                cancelButtonText: this.$t('qu_xiao'),
                inputValue: dept.name
              }).then(action => {
                departmentUpdateName({
                  uuid: dept.uuid,
                  name: action.value,
                }).then(res => {

                  this.$message.success(this.$t('geng_xin_cheng_gong'))
                  if (this.newDepartment !== null) {
                    this.newDepartment()
                  }
                  dept.name = action.value
                })
              })
            },
            search() {
                if (this.table === 'users') {
                    this.searchUser()
                } else {
                    this.searchDevice()
                }
            },
            showUsers(){
                this.table = `users`
                this.$refs.userList.initDepartment(this.group.uuid)
            },
            showDevices() {
                this.table = `devices`
                this.$refs.deviceList.initDevice(this.group.uuid)
            },
            handleAddUser() {
                this.user = {
                    departmentUuid: '',
                    name: '',
                    avatar: 'https://sass-img.iyyclub.com/avatar.jpg',
                    phone: '',
                    password: ''
                }
                this.addUserVisible = true
            },

            createDepartment(){
                let vue = this
                if (!vue.departmentName.length) {
                    vue.$message.warning(this.$t('qing_shu_ru_bu_men_ming_cheng'))
                    return
                }

                groupCreate({name: vue.departmentName, parentUuid: vue.group.uuid}).then(() => {
                    if (vue.newDepartment !== null) {
                        vue.newDepartment()
                    }
                    vue.addGroupVisible = false
                })
            },
            searchUser(){
                this.$refs.userList.initDepartment(this.group.uuid, this.searchInfo)
            },

            searchDevice(){
                this.$refs.deviceList.initDevice(this.group.uuid, this.searchInfo)
            },
            handleDepartmentBindUser(){
                let vue = this
                let res = checkPhone(vue.user.phone)
                if (!res.status) {
                    vue.$message.error(res.msg)
                    return
                }

                if (!vue.user.name.length) {
                    vue.$message.error(this.$t('qing_shu_ru_yuan_gong_ming_cheng'))
                    return
                }

                if (!vue.user.password.length) {
                    vue.$message.error(this.$t('qing_shu_ru_yuan_gong_deng_lu_mi_ma'))
                    return
                }
                vue.user.departmentUuid = vue.group.uuid
                vue.user.password = hex_md5(vue.user.password)
                departmentBindUser(vue.user).then(() => {
                    vue.addUserVisible = false
                    vue.$refs.userList.initDepartment(vue.group.uuid)
                })
            },
            closeAllocated(){
                this.allocatedVisible = false
            },
            handleAllocateDevice(){
                this.allocatedVisible = true
            },
            deviceAllocate(){
                let vue = this
                let devices = vue.$refs.allocDevice.deviceAllocate()
                if (!devices.length) {
                    this.$message.warning(this.$t('qing_xuan_qu_xu_yao_fen_pei_de_she_bei'))
                } else {
                    deviceAllocateGroup({groupUuid: vue.group.uuid, devices: devices}).then(() => {
                        vue.allocatedVisible = false
                    })
                }
            },
        },
    }
</script>

<style lang="scss">
    .group {
        height: 100%;
        display: flex;
        flex-direction: column;
        .group-title {
            height: $_header_sec_height;
            line-height: 1;
            border-bottom: 1px solid $f_50_color;
            display: flex;
            .group-title-name {
                flex: 1;
                border-left: 4px solid $f_color;
                margin-top: 1px;
                font-size: .9rem;
                padding: 0 .5rem;
                color: $f_sec_color;
                font-weight: $w1;
                height: $_header_sec_height;
                line-height: $_header_sec_height;
              span.operate {
                font-weight: normal;
                font-size: .6rem;
                color: $f_color;
                cursor: pointer;
              }

            }
            .group-title-operate {
                height: $_header_sec_height;
                line-height: $_header_sec_height;
                font-size: .6rem;
                padding: 0 .8rem;
                span {
                    display: inline-block;
                }
                span.operate {
                    color: $f_sec_color;
                    cursor: pointer;
                }
                span.operate:hover {
                    color: $f_color;
                }

                span.split {
                    margin: 0 .5rem;
                }

              span.delete{
                color: $btn_sec_color;
              }
            }
        }

        $group-radius: .3rem;

        .group-filter {
            padding: $padding;
            .group-list-filter {
                border-radius: $group-radius;
                height: 2rem;
                line-height: 1.1;
                span {
                    padding: .5rem 0 .5rem .5rem;
                    width: 8rem;
                    text-align: center;
                    font-size: $filter-font-size;
                    display: inline-block;
                    color: $f_sec_color;
                    border: 1px solid $f_color;
                    cursor: pointer;
                }
                span.active {
                    color: $f_th_color;
                    background-color: $f_color;
                }

                span:hover {
                    color: $f_th_color;
                }
                span:first-child {
                    border-top-left-radius: $group-radius;
                    border-bottom-left-radius: $group-radius;
                }



                span:last-child {
                    padding-right: .5rem;
                    border-top-right-radius: $group-radius;
                    border-bottom-right-radius: $group-radius;
                }

            }
        }
        .group-list-item {
            flex: 1;
            overflow-y: scroll;
        }

        .group-btn {
            margin-top: $padding;
            .el-col:first-child {
                text-align: right;
            }
            .el-col:last-child {
                text-align: left;
            }
            .el-col {

                .cancel {
                    background-color: transparent;
                    margin-right: $padding;
                }
                .submit {
                    margin-left: $padding;
                    color: $f_th_color;
                    background-color: $f_color;
                }
                .submit:hover {
                    color: $f_th_color;
                }
            }
        }

        .add-user-form {
            padding: $padding;
            .department-user-img {
                width: 3rem;
                height: 3rem;
                line-height: 3rem;
                background-color: $bg_sec_color;
            }
        }
    }
</style>
